<template>
  <div class="container-lg max-width-1200 position-relative mb-3" v-if="userInfo && userInfo.Role==2" >
    <div class="w-100 list-group mb-3  bg-white my-3" >
      <div class="py-3 mx-2 d-flex align-content-center justify-content-between border-bottom">
        <div class="fw-bold  my-0 lh-base h6" >沭聚物联反馈审核管理</div>
        <div class="d-flex align-items-center">
          <div class="selected-box my-0 lh-base d-flex align-items-center me-2">
            <label for="sele1" class="flex-shrink-0 text-secondary small">筛选：</label>
            <select class="form-select form-select-sm  rounded-0 " @change="getList(true)" v-model="params.status" id="sele1" aria-label="请选择" >
              <option value="">全部</option>
              <option value="0">待审核</option>
              <option value="1">已通过</option>
              <option value="2">未通过</option>
            </select>
          </div>
          <button @click="openAnnounceReq"  class="btn btn-sm btn-primary me-1 flex-shrink-0" type="button"><i class="bi bi-send-fill me-1"></i>发布问题</button>
        </div>
      </div>
      <!--没有数据-->
      <NodataCom :show="showNodata"></NodataCom>
      <!--  正在加载-->
      <LoadingCom :show="showLoading"></LoadingCom>
      <!--    列表-->
      <div class="p-2 list-box " v-for="(item,index) of list" :key="index">
        <div class="bg-light p-2">
          <div class="d-flex align-content-center justify-content-between  rounded-2 mb-2">
            <div class=" w-auto my-0 lh-base " >
              <div class="fw-bold title-left me-3 point-curser pub-hover-primary" @click="goto(item)">
                <text v-if="!item.ParentId">问题： {{item.Title}}</text>
                <text v-else>评论</text>
              </div>
            </div>
            <span class="badge title-badge badge-blue-green rounded-pill px-2 flex-shrink-0" v-if="item.Status===1">审核通过</span>
            <span class="badge title-badge badge-little-lightblue rounded-pill px-2 flex-shrink-0" v-else-if="item.Status===0">待审核</span>
            <span class="badge title-badge text-bg-warning text-white rounded-pill px-2 flex-shrink-0" v-else-if="item.Status===2">未通过</span>
          </div>
          <div class="row g-2">
            <div class="col-12 col-md-7 d-flex align-items-center justify-content-start flex-wrap">
              <small class="small me-3 text-body-secondary mb-1">发布时间：{{item.CreatedAtdeal}}</small>
              <small class="small text-body-secondary mb-1">
                发布人：{{item.Tel || "************"}}
              </small>
            </div>
            <div class="col-12 col-md-5 d-flex align-items-center justify-content-end">
              <!--              <text class="text-success small" v-if="item.Status==1 ">已通过</text>-->
              <!--              <text class="text-success small" v-if="item.Status==2 ">未通过</text>-->
              <button type="button" class="btn ms-3 btn-link text-decoration-none fw-bold btn-sm small-btn-size" @click="goto(item)">去审核</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <PaginationCom
        @pageChange="pageChangeFun($event)"
        :totalIn="total"
        :currentIn="params.current"
        :pageSizeIn="params.pageSize"
    ></PaginationCom>
  </div>
  <!--  无法访问-->
  <div class="container-lg max-width-1200 position-relative mb-3" v-else>
    <div  class="w-100 list-group mb-3  bg-white" >
      <div class="d-flex flex-column align-items-center justify-content-center py-4">
        <button class="mt-4 btn btn-primary" >无法查看</button>
        <text class="small mt-2 text-secondary">无法查看信息，您无该模块的访问权限</text>
      </div>
    </div>
  </div>


</template>

<script setup>
// import AnnounceRequirementModel from "@/components/AnnounceRequirementModel"
import NodataCom from "@/layout/NodataCom"
import LoadingCom from "@/layout/LoadingCom"
import {computed, onMounted, reactive, ref} from "vue";
import {getMyDemands,cancelDemand} from "@/api/Demand";
import router from "@/router";
import {formatTime} from "@/utils/dateFun";
import {showToast} from "@/utils/toast";
import {Modal} from 'bootstrap'
const callbackState = ref(false);
let quitModelRef = "" // 取消模态框 实例
const quitModel = ref() // 取消模态框 dom
import {useStore} from "vuex";
import {getPostsByAdmin} from "@/api/competition";
const store = useStore()
const  userInfo = computed(()=>store.state.loginModel.userInfo) || {}
const params = reactive({
  boardId:2, // 版块 ID 查询(必填)。1 表示大赛板块，2 表示合作方产品板块
  title:"",// 关键字
  pageSize:10,//每页条数
  current:1, // 当前页数
  status:"0", //0 审核中，1 审核通过，2 审核不通过 （版主有效）
})
let choisedItem = ""; // 被选中的要操作的
const total  = ref(0)
// 发布需求
const openAnnounceReq = ()=>{
  // showAnnounceRequirementModel.value = true
  router.push({path:"/shujuwulianquestionadd"})
}

const list = ref({})
const showNodata = ref(false)
const showLoading = ref(false)
onMounted(()=>{
  getList()
})
const pageChangeFun = (e)=>{
  params.current = e.page
  params.pageSize = e.pageSize
  getList()
}
// 获取消息列表
const getList = async (currentinit)=>{
  if(currentinit){
    params.current = 1
  }
  showLoading.value = true
  showNodata.value = false
  list.value = []
  total.value = 0
  const res =await getPostsByAdmin({...params,status:params.status!==""?params.status-0:""})
  showLoading.value = false
  if(res.err_code==0){
    const data =  res.data || []
    data.forEach(item=>{
      if(item.CreatedAt){
        item.CreatedAtdeal = formatTime(item.CreatedAt)
      }
      if(item.Account && item.Account.Tel){
        item.Tel = item.Account.Tel
      }
    })
    list.value = data
    total.value = res.total || 0
    if(data.length<=0){
      showNodata.value = true
    }
  }else{
    showToast("danger",res.err_msg || "请求出错")
  }
}


const goto = (item) => {
  // router.push({path:'/CompetitionQAdmin',query:{id:item.ID}})
  const routeData = router.resolve({
    path:'/shujuwulianquestionQAdmin',query:{id:item.ID}
  });
  window.open(routeData.href, '_blank');
}


</script>

<style scoped lang="scss">

.title-left{
  word-break: break-all;
}
.title-badge{
  height: 1.5rem;
  line-height: 1rem;
  font-size: 0.7rem;
  font-weight: normal;
  width: 5rem;
}
.small{
  font-size: 0.9rem;
}
.list-box{
  box-sizing: border-box;
}

.small-btn-size{
  height: 1.5rem;
  line-height: 1rem;
}

.btn-check + .btn{
  border: none;
}
.btn-check:checked + .btn{
  color: #0d6efd;
}

</style>
